import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TertiaryButton, TabsPanel, ContentLoader, TertiaryButtonGroup } from '@dev/ee-components';
import { goBack as GoBack } from 'redux-first-history';
import styled from 'styled-components';
import useMobile from '@/services/hooks/useMobile';

import { getEmailsStore } from '@/store/emails/actions';
import { ShowDialog } from '@/store/dialog/actions';

import { ShowDialogParams } from '@/store/dialog/types';

import EmailHeaders from '../EmailHeaders';

const HeaderContainer = styled.div`
    margin-bottom: 32px;
`;

const Header = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isMobile = useMobile();

    const { email, emailLoading } = useSelector(getEmailsStore);

    const showInNewWindow = (): void => {
        const EmailPreview = window.open('', 'EmailPreview');
        EmailPreview.document.write(email?.Preview?.Body);
    };

    const showEmailHeaders = (): void => {
        const headers = <EmailHeaders headers={email.Headers} />;

        const params: ShowDialogParams = {
            title: t('emailheaders'),
            cancelLabel: t('close'),
            body: headers,
        };
        dispatch(ShowDialog(params));
    };

    const title = emailLoading ? <ContentLoader mode="row" width={220} /> : email?.Preview.Subject;

    return (
        <HeaderContainer>
            <TabsPanel title={title} breadcrumbsOnClick={GoBack} isMobile={isMobile} />
            <TertiaryButtonGroup>
                <TertiaryButton onClick={showInNewWindow} text={t('viewinnewwindow')} />
                <TertiaryButton onClick={showEmailHeaders} text={t('emailheaders')} />
            </TertiaryButtonGroup>
        </HeaderContainer>
    );
};

export default Header;
